import { ApiRequestInterceptor } from "./apiRequest";
import { RESTAURANTS } from "../Constants/Endpoints";

export const fetchEditMyRestaurant = async (restauranteId, body) => {
    const method = "PUT";
    const url = `${RESTAURANTS.editMyRestaurant}/${restauranteId}`;
    const response = await ApiRequestInterceptor(url, method, body);

    // Aseguramos que devuelva statusCode
    return {
        statusCode: response.statusCode || 200,  // 👈 si no viene, asumimos 200
        ...response,
    };
};

